module.exports = __webpack_public_path__ + "img/DiNapoli-1.7bdacdf2.png";